// services/support/knowledgeService.ts
import axios from "axios";
import { KnowledgeArticle } from "../../types/features/support/KnowledgeArticle";
import { MAIN_API_URL } from "../../config/api";

export const knowledgeService = {
  // GET /api/knowledge - avec pagination
  async getAllArticles(page: number = 1, perPage: number = 20): Promise<any> {
    const response = await axios.get(`${MAIN_API_URL}/knowledge`, {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  async searchArticles(query: string): Promise<KnowledgeArticle[]> {
    const response = await axios.get(`${MAIN_API_URL}/knowledge/search`, {
      params: { q: query },
    });
    return response.data;
  },

  async getArticleById(id: string): Promise<KnowledgeArticle | null> {
    const response = await axios.get(`${MAIN_API_URL}/knowledge/${id}`);
    return response.data;
  },

  async getArticleBySlug(slug: string): Promise<KnowledgeArticle | null> {
    const response = await axios.get(`${MAIN_API_URL}/knowledge/slug/${slug}`);
    return response.data;
  },

  async createArticle(data: Omit<KnowledgeArticle, "id" | "created_at" | "updated_at">): Promise<KnowledgeArticle> {
    const response = await axios.post(`${MAIN_API_URL}/knowledge`, data);
    return response.data;
  },

  async updateArticle(id: string, data: Partial<KnowledgeArticle>): Promise<KnowledgeArticle> {
    const response = await axios.put(`${MAIN_API_URL}/knowledge/${id}`, data);
    return response.data;
  },

  async deleteArticle(id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/knowledge/${id}`);
  },
};
